import { defineAsyncComponent, type Component } from 'vue'
import type { DocumentStatus } from '@/types'
import type { ModalName } from '@/types/modal'

// Lazy-loaded modal components
const EditPeselModalComponent = defineAsyncComponent(
  () => import('@/components/widgets/modal/EditPeselModal.vue')
)

const VolunteerCooperationModalComponent = defineAsyncComponent(
  () => import('@/components/widgets/modal/VolunteerCooperationModal.vue')
)

const ChangeSchoolModalComponent = defineAsyncComponent(
  () => import('@/components/widgets/modal/ChangeSchoolModal.vue')
)

const UnexpectedErrorModalComponent = defineAsyncComponent(
  () => import('@/components/widgets/modal/UnexpectedErrorModal.vue')
)

// Map modal names to their components
export const MODAL_COMPONENTS = {
  editPesel: EditPeselModalComponent,
  volunteerCooperation: VolunteerCooperationModalComponent,
  changeSchool: ChangeSchoolModalComponent,
  unexpectedError: UnexpectedErrorModalComponent
} as const satisfies Record<ModalName, Component>

export const EMPTY_MODAL_STATE = {
  name: null,
  data: undefined,
  component: null
} as const

// Volunteer cooperation status configurations
export const VOLUNTEER_COOPERATION_STATUS = {
  active: {
    display_value: 'childCard.volunteerCooperation.status.active',
    color: '96EAFF'
  },
  inactive: {
    display_value: 'childCard.volunteerCooperation.status.inactive',
    color: 'DA97F0'
  }
} as const satisfies Record<string, DocumentStatus>
